import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async fetchStudentList(page, school_id) 
  {
    let data = {
      "page": page,
      "school_id":school_id,
      
    };
    let response = await apiCall("student/list", data);

    return response;
  },

  async fetchAllStudents(page) 
  {
    let data = {
      "page": page
    };
    let response = await apiCall("student/list", data);

    return response;
  },

  async sortAllStudents(page) 
  {
    let data = {
      "page": page
    };
    let response = await apiCall("student/list/recently_added", data);

    return response;
  },

  async activateUnpaidAccount(user_id) 
  {
    let data = {
      "account_id": user_id
    };
    let response = await apiCall("student/activate", data);

    return response;
  },

  async deactivateStudentAccount(user_id) 
  {
    let data = {
      "account_id": user_id
    };
    let response = await apiCall("student/deactivate", data);

    return response;
  },

  async fetchGroupStudents(page, group_id) 
  {
    let data = {
      "page": page,
      "group_id":group_id,
      
    };
    let response = await apiCall("student/list", data);

    return response;
  },

  async fetchStudentsToday(school) {
    let data = {
      "school":school
    };
    let response = await apiCall("student/today", data);
    return response;
  },
  async fetchStudentsTodayLimit(school,limit) {
    let data = {
      "school":school,
      "limit":limit
    };
    let response = await apiCall("student/today", data);
    return response;
  },
  async fetchAllStudentsToday(data) {
    let response = await apiCall("student/today", data);
    return response;
  },

  async createStudent(data) {
    let response = await apiCall("student/add", data);
    return response;
  },

  async importStudents(data) {
    let response = await apiCall("student/import", data);
    return response;
  },

  async updateStudent(data) {
    let response = await apiCall("student/update", data);

    return response;
  },

  async fetchStudentNumber(school) {
    let data = {
      school_id: school
    };
    let response = await apiCall("student/count", data);
    return response;
  },
  async fetchAllStudentsNumber(data) {
    let response = await apiCall("student/count", data);
    return response;
  },
  async fetchStudentData(student_id) {
    let data = {
      student_id: student_id
    };
    let response = await apiCall("student/studentInfo", data);

    return response;
  },
  async fetchStudentContacts(student_user_id) {
    let data = {
      student_user_id: student_user_id
    };
    let response = await apiCall("admin/list_student_contacts", data);

    return response;
  },
  async searchAllStudents(search, page) {
    let data = {
      search: search,
      page: page
    };
    let response = await apiCall("student/list", data);
    return response;
  },

  async searchSchoolStudents(page, school_id, search) {
    let data = {
      
      page: page,
      school_id: school_id,
      search: search
    };
    let response = await apiCall("student/list", data);
    return response;
  },
  async searchGroupStudent(page, group_id, search) {
    let data = {
      page: page,
      group_id: group_id,
      search: search
      
    };
    let response = await apiCall("student/list", data);
    return response;
  },
  async fetchStudentCardList(data) {
    let response = await apiCall("student/student_cards", data);
    return response;
  },
  async setDefaultPin(account_id) {
    let data = {
      account_id: account_id
    };
    let response = await apiCall("user/pin/default", data);
    return response;
  },
  async addContact(data) {
    let response = await apiCall("relative/add", data);
    return response;
  },
  async getParentStudentsInSameSchool(school_id, parent_user_id, ) {
    let data = {
      school_id: school_id,
      parent_user_id: parent_user_id,
      
    };
    let response = await apiCall("admin/list_parent_students/school", data);
    return response;
  },
  async countStudentContacts(student) {
    let data = {
      student_user_id: student,
    };
    let response = await apiCall("admin/count_student_contacts", data);
    return response;
  },
  async searchStudentByNumber(number) {
    let data = {
      number: number,
    };
    let response = await apiCall("student/search/code", data);
    return response;
  },
  async transferStudent(student_id, school_to, group_to) {
    let data = {
      student_id: student_id,
      school_to: school_to,
      group_to: group_to
    };
    let response = await apiCall("student/transfer", data);
    return response;
  },
  async listStudentTransfers(student_id) {
    let data = {
      student_id: student_id
    };
    let response = await apiCall("student/list/transfers", data);
    return response;
  },
  async turnOnRestrictions(student_id) {
    let data = {
      "student_id": student_id
    };
    let response = await apiCall("student/restrictions/on", data);
    return response;
  },
  async turnOffRestrictions(student_id) {
    let data = {
      "student_id": student_id
    };
    let response = await apiCall("student/restrictions/off", data);
    return response;
  },
  async payActivationFee(user_id, phone_number, cardType) {
    let data = {
      "user_id": user_id,
      "phone_number": phone_number,
      "card_type":cardType
    };
    let response = await apiCall("bank/activate/account", data);
    return response;
  },
  async payRenewalFee(user_id, phone_number, replacementType) {
    let data = {
      "user_id": user_id,
      "phone_number": phone_number,
      "replacement_type": replacementType
    };
    let response = await apiCall("card/replace/payment", data);
    return response;
  },
  async importStudentsandContacts(data) {
    let response = await apiCall("admin/import_students_and_contacts", data);
    return response;
  },
  async editContactName(link_id, contact_name) {
    let data = {
      "id": link_id,
      "contact_name": contact_name
    };
    let response = await apiCall("student/edit_contact_name", data);
    return response;
  },
  async deleteStudentContact(contact_id) {
    let data = {
      link_id: contact_id
    };
    let response = await apiCall("mobile/webapp/delete_student_contact", data);
    return response;
  },
  async totalActivationsPerSchool(data) {
    let response = await apiCall("user/useractivation/school/count_total_activations", data);
    return response;
  },
  async sumAndCountOfActivationsPerSchool(data) {
    let response = await apiCall("account_activations/sum_and_count_per_school", data);
    return response;
  },
  async totalActivationsPerRole(data) {
    let response = await apiCall("user/useractivation/role/count_total_activations", data);
    return response;
  },
  async totalReplacementsPerSchool(data) {
    let response = await apiCall("invoice/count_replacements_per_school", data);
    return response;
  },
  async searchTotalActivationsPerSchool(from, to) {
    let data = {
      from: from,
      to: to
    };
    let response = await apiCall("user/useractivation/school/count_total_activations", data);
    return response;
  },
  async searchSumAndCountOfActivationsPerSchool(from, to) {
    let data = {
      from: from,
      to: to
    };
    let response = await apiCall("account_activations/sum_and_count_per_school", data);
    return response;
  },
  async searchTotalActivationsPerRole(from, to) {
    let data = {
      from: from,
      to: to
    };
    let response = await apiCall("user/useractivation/role/count_total_activations", data);
    return response;
  },
  async searchTotalReplacementsPerSchool(from, to) {
    let data = {
      from: from,
      to: to
    };
    let response = await apiCall("invoice/count_replacements_per_school", data);
    return response;
  },
  
  async totalActivationsPerSchoolToday(data) {
    let response = await apiCall("user/useractivation/count_today_activations_per_school", data);
    return response;
  },
  async totalReplacementsPerSchoolToday(data) {
    let response = await apiCall("invoice/count_replacements_per_school_today", data);
    return response;
  },
  async activationsToday(data) {
    let response = await apiCall("user/useractivation/count_today_activations", data);
    return response;
  },
  async replacementsToday(data) {
    let response = await apiCall("invoice/count_replacements_today", data);
    return response;
  },
  async searchAllActivations(page, school_id, search, from, to, role_id) {
    let data = {
      page: page,
      school_id: school_id,
      search: search,
      from: from,
      to: to,
      role_id: role_id
      
    };
    let response = await apiCall("user/useractivation/list_all_activations", data);
    return response;
  },
  async searchReplacements(page, school_id, search, from, to) {
    let data = {
      page: page,
      school_id: school_id,
      search: search,
      from: from,
      to: to,
      
    };
    let response = await apiCall("mobile/webapp/invoice/list_all_replacements", data);
    return response;
  },
  async listAllActivations(page) {
    let data = {
      page: page
      
    };
    let response = await apiCall("user/useractivation/list_all_activations", data);
    return response;
  },
  async listAllReplacements(page) {
    let data = {
      page: page
      
    };
    let response = await apiCall("mobile/webapp/invoice/list_all_replacements", data);
    return response;
  },
  async countAllActivations(data) {
    let response = await apiCall("user/useractivation/count_activations", data);
    return response;
  },
  async countAllReplacements(data) {
    let response = await apiCall("invoice/count_total_replacements", data);
    return response;
  },
  async searchAllCreditBalances(page, school_id, search) {
    let data = {
      page: page,
      school_id: school_id,
      search: search
      
    };
    let response = await apiCall("mobile/webapp/buzztime_balance/students/report", data);
    return response;
  },
  async listAllCreditBalances(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/buzztime_balance/students/report", data);
    return response;
  },
  async listAllSchoolCreditBalances(page, school_id) {
    let data = {
      page: page,
      school_id: school_id
    };
    let response = await apiCall("mobile/webapp/buzztime_balance/students/report", data);
    return response;
  },
  async searchAllPocketMoneyBalances(page, school_id, search, group_id, balance) {
    let data = {
      page: page,
      school_id: school_id,
      search: search,
      group_id: group_id,
      balance: balance
      
    };
    let response = await apiCall("mobile/webapp/pocket_money_balance/students/report", data);
    return response;
  },
  async listAllPocketMoneyBalances(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/pocket_money_balance/students/report", data);
    return response;
  },
  async listAllSchoolPocketMoneyBalances(page, school_id) {
    let data = {
      page: page,
      school_id: school_id
    };
    let response = await apiCall("mobile/webapp/pocket_money_balance/students/report", data);
    return response;
  },
  async blockStudentContact(contact_id) {
    let data = {
      link_id: contact_id
    };
    let response = await apiCall("mobile/webapp/block_contact", data);
    return response;
  },
  async unBlockStudentContact(contact_id) {
    let data = {
      link_id: contact_id
    };
    let response = await apiCall("mobile/webapp/unblock_contact", data);
    return response;
  },
  async searchAllInactiveStudents(page, school_id, search, weeks, group) {
    let data = {
      page: page,
      school_id: school_id,
      search: search,
      weeks: weeks,
      group_id: group
      
    };
    let response = await apiCall("mobile/webapp/inactive_wallet_users/list", data);
    return response;
  },
  async searchAllActiveStudents(page, school_id, search, weeks, group) {
    let data = {
      page: page,
      school_id: school_id,
      search: search,
      weeks: weeks,
      group_id: group
      
    };
    let response = await apiCall("mobile/webapp/active_wallet_users/list", data);
    return response;
  },
  async listAllInactiveStudents(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/inactive_wallet_users/list", data);
    return response;
  },
  async listAllActiveStudents(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/active_wallet_users/list", data);
    return response;
  },
  async countInactiveStudentAccounts() {
    let data = {
      weeks: 4
    };
    let response = await apiCall("student/inactive/count", data);
    return response;
  },
  async countActiveStudentAccounts() {
    let data = {
      weeks: 2
    };
    let response = await apiCall("student/active/count", data);
    return response;
  },
  async getSchoolActiveStudents() {
    let data = {
      weeks: 2
    };
    let response = await apiCall("student/active/count_by_school", data);
    return response;
  },

  async getPocketMoneyLimit(user_id) {
    let data = {
      user_id: user_id,
    };
    let response = await apiCall("student/pocket_money_limit", data);
    return response;
  },
  async printAllStudentCreditBalances(school_id) {
    let data = {
      school_id: school_id,
    };
    let response = await apiCall("mobile/webapp/buzztime_balance/students/report/print", data);
    return response;
  },
  async printAllStudentPocketMoneyBalances(school_id, group, balance) {
    let data = {
      "school_id":school_id,
      "group_id":group,
      "balance":balance
      
    };
    let response = await apiCall("mobile/webapp/pocket_money_balance/students/report/print", data);
    return response;
  },

  async accessStudentLogs(page, user_id) 
  {
    let data = {
      "page": page,
      "user_id":user_id,
      
    };
    let response = await apiCall("mobile/webapp/student_access_logs/list", data);
    return response;
  },
  async printAllInactiveStudents(school_id, search, weeks, group) {
    let data = {
      "school_id": school_id,
      "search":search,
      "weeks":weeks,
      "group_id":group
      
    };
    let response = await apiCall("mobile/webapp/inactive_wallet_users/print", data);
    return response;
  },
  async printAllActiveStudents(school_id, search, weeks, group) {
    let data = {
      "school_id": school_id,
      "search":search,
      "weeks":weeks,
      "group_id":group
      
    };
    let response = await apiCall("mobile/webapp/active_wallet_users/print", data);
    return response;
  },
  async printAllStudents(school_id) {
    let data = {
      "school_id": school_id  
    };
    let response = await apiCall("mobile/webapp/student_list/printable", data);
    return response;
  },
  async syncAuthumAccount(user_id, username) {
    let data = {
      "student_user_id": user_id,
      "username": username  
    };
    let response = await apiCall("student/update/authum_id", data);
    return response;
  },
  async updateStudentGroup(student_id, group_id, authum_student_id) {
    let data = {
      student_id: student_id,
      group_id: group_id,
      authum_student_id: authum_student_id
    };
    let response = await apiCall("student/update/group", data);
    return response;
  },
  async searchAuthumStudent(student_name, school_code) {
    let data = {
      student_name: student_name,
      school_code: school_code
    };
    let response = await apiCall("mobile/webapp/student_authum_search", data);
    return response;
  },
  async createAuthumStudent(data) {
    let response = await apiCall("student/add/authum", data);
    return response;
  },
  async syncAuthumDetails(user_id, authum_id) {
    let data = {
      "student_user_id": user_id,
      "authum_id": authum_id  
    };
    let response = await apiCall("student/update/authum_data", data);
    return response;
  },
  async addMissingStudent(first_name, surname, gender, school_code, class_name) {
    let data = {
      "first_name": first_name,
      "surname": surname,
      "gender":gender,
      "school_code":school_code,
      "class_name":class_name  
    };
    let response = await apiCall("student/add/missing", data);
    return response;
  },

  async getStudentRank(student_user_id) {
    let data = {
      student_user_id: student_user_id
    };
    let response = await apiCall("student/school/rank", data);
    return response;
  },
  async getStudentFingerprintStatus(student_id) 
  {
    let data = {
      "student_id": student_id
    };
    let response = await apiCall("mobile/webapp/student_fingerprint_status", data);

    return response;
  },
  async totalRegistrationsPerSchoolToday(data) {
    let response = await apiCall("student/registrations/count", data);
    return response;
  },
  async getStudentAuthumRegNo(student_id) 
  {
    let data = {
      "student_id": student_id
    };
    let response = await apiCall("mobile/webapp/student_authum_reg_no", data);

    return response;
  },
  async sharePocketMoney(data) {
    let response = await apiCall("mobile/webapp/share_pocket_money", data);
    return response;
  },
  async printAllNoPhotoStudents(school_id) {
    let data = {
      "school_id":school_id  
    };
    let response = await apiCall("student/list_without_photo/printable", data);
    return response;
  },
  async searchAllNoPhotoStudents(page, school_id, search) {
    let data = {
      "page": page,
      "school_id":school_id,
      "search":search
    };
    let response = await apiCall("student/list_without_photo", data);
    return response;
  },
  async listAllNoPhotoStudents(page) {
    let data = {
      "page": page 
    };
    let response = await apiCall("student/list_without_photo", data);
    return response;
  },
  async searchAllNoPrintStudents(page, school_id, search) {
    let data = {
      "page": page,
      "school_code":school_id,
      "search":search
    };
    let response = await apiCall("mobile/webapp/unenrolled_fingerprints", data);
    return response;
  },
  async printAllNoPrintStudents(school_id, group) {
    let data = {
      "school_code":school_id,
      "group":group  
    };
    let response = await apiCall("mobile/webapp/unenrolled_fingerprints/printable", data);
    return response;
  },
  async listAllNoContactStudents(page) {
    let data = {
      "page": page 
    };
    let response = await apiCall("mobile/webapp/students_with_no_contacts", data);
    return response;
  },
  async searchAllNoContactStudents(page, school, group) {
    let data = {
      "page": page,
      "school":school,
      "group":group
    };
    let response = await apiCall("mobile/webapp/students_with_no_contacts", data);
    return response;
  },
  async printAllNoContactStudents(school, group) {
    let data = {
      "school":school,
      "group":group  
    };
    let response = await apiCall("mobile/webapp/students_with_no_contacts/printable", data);
    return response;
  },
  async deleteFingerprint(student_id) {
    let data = {
      student_id: student_id
    };
    let response = await apiCall("student/delete_fingerprint", data);
    return response;
  },
  async getStudentFingerprintEnrollmentDate(student_id) 
  {
    let data = {
      "student_id": student_id
    };
    let response = await apiCall("mobile/webapp/student_fingerprint_enrollment_date", data);

    return response;
  },
  async activateFaceStatus(data) {
    let response = await apiCall("student/import/face_status", data);
    return response;
  },
  async getStudentFaceStatus(student_id) 
  {
    let data = {
      "student_id": student_id
    };
    let response = await apiCall("mobile/webapp/student_face_status_and_enrollment_date", data);

    return response;
  },
  async searchAllNoFaceStudents(page, school_id, search) {
    let data = {
      "page": page,
      "school_code":school_id,
      "search":search
    };
    let response = await apiCall("mobile/webapp/unenrolled_faces", data);
    return response;
  },
  async printAllNoFaceStudents(school_id, group) {
    let data = {
      "school_code":school_id,
      "group":group  
    };
    let response = await apiCall("mobile/webapp/unenrolled_faces/printable", data);
    return response;
  },
  async printAllActivationBonusStudents(school_id, from, to) {
    let data = {
      "school":school_id,
      "from":from,
      "to":to  
    };
    let response = await apiCall("mobile/webapp/students_with_only_activation_bonus/print", data);
    return response;
  },
  async searchAllActivationBonusStudents(page, school_id, from, to) {
    let data = {
      "page": page,
      "school":school_id,
      "from":from,
      "to":to
    };
    let response = await apiCall("mobile/webapp/students_with_only_activation_bonus", data);
    return response;
  },
  async listAllActivationBonusStudents(page) {
    let data = {
      "page": page 
    };
    let response = await apiCall("mobile/webapp/students_with_only_activation_bonus", data);
    return response;
  },
  async printAllFullyDormantStudents(school_id, startDate, endDate) {
    let data = {
      "school_id":school_id,
      "type":"fully",
      "from":startDate,
      "to":endDate  
    };
    let response = await apiCall("mobile/webapp/dormant_accounts/print", data);
    return response;
  },
  async searchAllFullyDormantStudents(page, school_id, startDate, endDate, search) {
    let data = {
      "page": page,
      "school_id":school_id,
      "type":"fully",
      "from":startDate,
      "to":endDate,
      "search":search
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
  async listAllFullyDormantStudents(page) {
    let data = {
      "page": page,
      "type":"fully" 
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
  async listSchoolFullyDormantStudents(page, school_id) {
    let data = {
      "page": page,
      "type":"fully",
      "school_id": school_id
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
  async printAllBoothDormantStudents(school_id, startDate, endDate) {
    let data = {
      "school_id":school_id,
      "type":"booth",
      "from":startDate,
      "to":endDate  
    };
    let response = await apiCall("mobile/webapp/dormant_accounts/print", data);
    return response;
  },
  async searchAllBoothDormantStudents(page, school_id, startDate, endDate, search) {
    let data = {
      "page": page,
      "school_id":school_id,
      "type":"booth",
      "from":startDate,
      "to":endDate,
      "search":search
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
  async listAllBoothDormantStudents(page) {
    let data = {
      "page": page,
      "type":"booth" 
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
  async listSchoolBoothDormantStudents(page, school_id) {
    let data = {
      "page": page,
      "type":"booth",
      "school_id": school_id
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
  async printAllPMDormantStudents(school_id, startDate, endDate) {
    let data = {
      "school_id":school_id,
      "type":"pocket",
      "from":startDate,
      "to":endDate  
    };
    let response = await apiCall("mobile/webapp/dormant_accounts/print", data);
    return response;
  },
  async searchAllPMDormantStudents(page, school_id, startDate, endDate, search) {
    let data = {
      "page": page,
      "school_id":school_id,
      "type":"pocket",
      "from":startDate,
      "to":endDate,
      "search":search
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
  async listAllPMDormantStudents(page) {
    let data = {
      "page": page,
      "type":"pocket" 
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
  async listSchoolPMDormantStudents(page, school_id) {
    let data = {
      "page": page,
      "type":"pocket",
      "school_id": school_id
    };
    let response = await apiCall("mobile/webapp/dormant_accounts", data);
    return response;
  },
   async countFullyDormantAccounts() {
    let data = {
      type: "fully"
    };
    let response = await apiCall("mobile/webapp/count_dormant_accounts", data);
    return response;
  },
  async countSchoolFullyDormantAccounts(school_id) {
    let data = {
      type: "fully",
      school_id: school_id
    };
    let response = await apiCall("mobile/webapp/count_dormant_accounts", data);
    return response;
  },
  async countBoothDormantAccounts() {
    let data = {
      type: "booth"
    };
    let response = await apiCall("mobile/webapp/count_dormant_accounts", data);
    return response;
  },
  async countSchoolBoothDormantAccounts(school_id) {
    let data = {
      type: "booth",
      school_id: school_id
    };
    let response = await apiCall("mobile/webapp/count_dormant_accounts", data);
    return response;
  },
  async countPMDormantAccounts() {
    let data = {
      type: "pocket"
    };
    let response = await apiCall("mobile/webapp/count_dormant_accounts", data);
    return response;
  },
  async countSchoolPMDormantAccounts(school_id) {
    let data = {
      type: "pocket",
      school_id: school_id
    };
    let response = await apiCall("mobile/webapp/count_dormant_accounts", data);
    return response;
  },
  async getTermlyFeeStatus(user_id) 
  {
    let data = {
      "student_user_id": user_id
    };
    let response = await apiCall("mobile/webapp/student_termly_fee_status", data);
    return response;
  },
  
 
  
};
